import React from "react";
import styled from "styled-components";
import { Trans } from "@coworker/locales";
import { NativeNumberKeyPad } from "./NativeNumberKeyPad";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import { RegexOptions } from "./shared/RegexOptions";

const Container = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: calc(100% - 40px);
  width: 100%;
  top: 0;
  left: 0;
  background: var(--white);
  margin-top: 10px;
  overflow-y: auto;
`;

const Title = styled("h1")`
  font-size: 28px;
  font-weight: bold;
  color: var(--grey900);
  margin: 55px 29px;
  margin-bottom: 0px;
`;

const InputWrapper = styled.div`
  margin: 10px 40px 10px 29px;
`;

const CapInfo = styled.div`
  font-size: 12px;
  color: var(--grey600);
`;

const CapWarning = styled.div`
  font-size: 12px;
  color: var(--success);
`;

const ButtonWrapper = styled.div`
  margin-top: 24px;
`;

const SUPPLIER_NUMBER_LENGTH = 5;

const CapText = ({ supplierNumber }: { supplierNumber: string }) =>
  supplierNumber.length < SUPPLIER_NUMBER_LENGTH ? (
    <CapInfo>
      <Trans values={{ length: SUPPLIER_NUMBER_LENGTH }}>maxNDigits</Trans>
    </CapInfo>
  ) : (
    <CapWarning>
      <Trans values={{ length: SUPPLIER_NUMBER_LENGTH }}>
        numberCanOnlyBeNDigits
      </Trans>
    </CapWarning>
  );

interface SupplierNumberValue {
  supplier_number: string;
}
interface SupplierNumberProps {
  value: SupplierNumberValue;
  bigTitle: string;
  instruction: React.ReactNode;
  onSubmit: (value: SupplierNumberValue) => void;
}

const SupplierNumber = ({
  value,
  bigTitle,
  onSubmit,
  instruction,
}: SupplierNumberProps) => {
  const [supplierNumber, setSupplierNumber] = React.useState<string>(
    value.supplier_number || ""
  );

  const containerRef = React.useRef(null);

  return (
    <Container ref={containerRef}>
      <Title>{bigTitle}</Title>
      <InputWrapper>
        <NativeNumberKeyPad
          keypadType="number"
          inputMode="numeric"
          disabled={false}
          onComplete={() => {
            onSubmit({
              supplier_number: supplierNumber,
            });
          }}
          onUpdate={(updatedValue: string) => {
            setSupplierNumber(updatedValue);
          }}
          initialValue={supplierNumber}
          maxLength={SUPPLIER_NUMBER_LENGTH}
          regexOptions={RegexOptions.ONLYNUMBERS}
        />
        <CapText supplierNumber={supplierNumber} />
        <ButtonWrapper>
          <FixaButton
            onClick={() => {
              onSubmit({
                supplier_number: supplierNumber,
              });
            }}
            type="primary"
            fluid
            disabled={supplierNumber.length < SUPPLIER_NUMBER_LENGTH}
          >
            <Trans>submitString</Trans>
          </FixaButton>
        </ButtonWrapper>
        <>{instruction}</>
      </InputWrapper>
    </Container>
  );
};

export default SupplierNumber;
